import { PayloadAction } from "@reduxjs/toolkit";
import { call, put, takeLatest, takeLeading } from "redux-saga/effects";
import { API_URL } from "utils/constants";
import { TRANSLATE } from "utils/helpers";
import { request } from "utils/request";

import { UpdateProfilePayload, UserMeApiResponse } from "../types";
import { actions } from "./slice";

let isFetchingProfile = false;

export function* handleGetProfile() {
  if (isFetchingProfile) return;
  isFetchingProfile = true;

  try {
    const response: UserMeApiResponse = yield call(
      request,
      `${API_URL}/user/me`,
      { method: "GET" },
    );

    if (!response?.data) {
      yield put(
        actions.getProfileError(
          TRANSLATE("ERRORS.SOMETHING_WENT_WRONG", { error: "" }),
        ),
      );
      return;
    }

    yield put(actions.getProfileSuccess(response.data));
  } catch (error) {
    yield put(
      actions.getProfileError(
        TRANSLATE("ERRORS.SOMETHING_WENT_WRONG", { error: "" }),
      ),
    );
  } finally {
    isFetchingProfile = false;
  }
}

export function* handleUpdateProfile(
  action: PayloadAction<{
    id: string;
    data: UpdateProfilePayload;
    callback?: () => void;
  }>,
) {
  const { id, data, callback } = action.payload;

  try {
    yield call(request, `${API_URL}/user/${id}/profile`, {
      method: "PATCH",
      body: JSON.stringify(data),
    });

    yield put(actions.updateProfileSuccess(data));

    if (callback) {
      yield call(callback);
    }
  } catch (error) {
    yield put(
      actions.updateProfileError(
        TRANSLATE("ERRORS.SOMETHING_WENT_WRONG", { error: "" }),
      ),
    );
  }
}

export function* profileSaga() {
  yield takeLeading(actions.getProfile.type, handleGetProfile);
  yield takeLatest(actions.updateProfile.type, handleUpdateProfile);
}

export default profileSaga;
